<template>
  <div class="live-list-wrap">
    <NavHeaderBar title="直播预告" rightArrow />

    <!-- 下拉选项 -->
    <van-dropdown-menu active-color="#1989fa">
      <van-dropdown-item v-model="column" :options="baseColumn" />
      <van-dropdown-item v-model="sort" :options="sortlist" />
    </van-dropdown-menu>

    <!-- 列表内容 -->
    <van-list v-model="loading" :finished="finished" @load="onLoad">
      <template v-if="total > 0">
        <div class="content">
          <LineContentItem
            v-for="item in baseList"
            :key="item.zbcode"
            :zbcode="item.zbcode"
            :ocode="item.ocode"
            :cover="item.zbcover"
            :name="item.zbname"
            :date="item.zbbegintime"
            :looks="item.zbclickon"
            :zbflag="item.zbzbflag"
          />
        </div>
      </template>
      <Default v-else />
    </van-list>
  </div>
</template>

<script>
import queryList from "@/mixins/queryList.js";
export default {
  name: "LiveList",
  mixins: [queryList],
  computed: {
    category() {
      const { category } = this.$route.query;
      return category;
    }
  },
  data: () => ({
    column: "",
    sort: "",
    flag: false
  }),
  watch: {
    // 观察分类与排序，发生变化就重新请求
    column: {
      handler: function(val) {
        this.updateToFetch(val, this.sort, true);
      }
    },
    sort: {
      handler: function(val) {
        this.updateToFetch(this.column, val, true);
      }
    }
  },
  methods: {
    onLoad() {
      this.updateToFetch(this.column, this.sort, false);
    },
    // 触发顶部下拉选项后更新列表请求
    updateToFetch(column, sort, reload = false) {
      const category = this.category;
      this.fetch({ category, column, sort }, reload);
    }
  }
};
</script>

<style lang="scss">
.live-list-wrap {
  padding-top: 46px;
  .content {
    padding: 0 12px;
  }
}
</style>
